import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Select from "react-select";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";
import GroupForm from "./components/GroupForm";

const NewGroup = () => {
  return (
    <div class="page">
      <h1>New Group</h1>
      <GroupForm />
    </div>
  );
};

export default NewGroup;
